import M$plugin$MeasureBarihm from './facade/js/measurebarihm';

if (!window.M.plugin) window.M.plugin = {};
window.M.plugin.MeasureBarihm = M$plugin$MeasureBarihm;
